import { ToggleList } from "~/components/lists";
import { HelpTopicCard } from "./HelpTopicCard";

export const HelpTopicList = () => {
  return <ToggleList modes={MODES} />;
};

const MODES = [{ name: "Grid", view: <HelpTopicCard /> }];
